"use client";

import { useUserConfig } from "@/contexts/user-config-context";
import { useEffect } from "react";

export function FontSizeWrapper({ children }: { children: React.ReactNode }) {
  const { config } = useUserConfig();
  
  useEffect(() => {
    const scale = config.fontSize ?? 1;
    document.body.style.setProperty('--font-size-scale', String(scale));
  }, [config.fontSize]);
  
  return <>{children}</>;
}
